/* eslint-disable jsx-a11y/alt-text */
import classNames from 'classnames';
import React from 'react';
import { ButtonLinkSize, ButtonLinkVariants } from './ButtonTypes';

import './Button.scss';

export default ({
  title,
  disabled,
  wrapperStyles,
  buttonStyles,
  variant = ButtonLinkVariants.primary,
  size = ButtonLinkSize.regular,
  onClick,
  icon,
  iconStyles,
  className,
  loading,
}) => {

  const buttonWrapperClasses = loading ? `button-wrapper ${size} loading` : `button-wrapper ${size}`;
  const buttonClasses = loading ? `button ${variant} ${size} loading` : `button ${variant} ${size}`;

  return (
    <div className={buttonWrapperClasses} style={wrapperStyles}>
      {!loading && icon && <img style={iconStyles} src={icon} />}
      <button
        disabled={disabled || loading}
        className={classNames(buttonClasses, { [className]: className })}
        style={buttonStyles}
        type={onClick ? '' : 'submit'}
        onClick={onClick}
      >
        {!loading && title}
      </button>
    </div>
  );
};
